import React from 'react'

const AlterProgressbar = (props) => {
  const { bgcolor, completed, progressText } = props;
  const containerStyles = {
    height: 20,
    width: "100%",
    backgroundColor: "#e0e0de",
    borderRadius: 50,
    margin: "0 300px 0 0",
  };

  const fillerStyles = {
    height: "100%",
    width: `${completed}%`,
    backgroundColor: bgcolor,
    borderRadius: "inherit",
    textAlign: "right",
  };

  const labelStyles = {
    padding: "1px 0 0 0",
    margin:"0 0 0 5px",
    color: "white",
    fontWeight: "bold",
    float:"left"
  };
  return (
    <div style={containerStyles}>
      <div style={fillerStyles}>
        <span style={labelStyles}>{`${progressText}`}</span>
      </div>
    </div>
  );
};

export default AlterProgressbar;
